import React from 'react';
import { Link } from 'react-router-dom';
import appConfig from '@config/app.config';

const environment = process.env.REACT_APP_SPARTACUS_ENVIRONMENT;

const envColors = {
  development: { color: '#fbbf24', bg: 'rgba(251, 191, 36, 0.2)' },
  staging: { color: '#f97316', bg: 'rgba(249, 115, 22, 0.2)' },
  homologation: { color: '#a78bfa', bg: 'rgba(167, 139, 250, 0.2)' },
  qa: { color: '#22d3ee', bg: 'rgba(34, 211, 238, 0.2)' },
  testing: { color: '#34d399', bg: 'rgba(52, 211, 153, 0.2)' },
};

const getEnvStyle = (env) => {
  const key = env?.toLowerCase() || '';
  return envColors[key] || { color: '#f87171', bg: 'rgba(248, 113, 113, 0.2)' };
};

const Logo = ({ collapsed }) => {
  const envStyle = getEnvStyle(environment);
  const showEnvBadge = environment && environment !== 'production';

  return (
    <div className="isoLogoWrapper">
      {collapsed ? (
        <div>
          <h3>
            <Link to="/">
              <img
                src={require('../../../assets/images/logo-spartacus.png')}
                style={{width: 35, height: 35}}
                alt="Sidebar Icon"
              />
            </Link>
          </h3>
        </div>
      ) : (
        <h3>
          <Link
            to="/"
            style={{
              color: '#ffffff',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: 70,
              gap: 8,
            }}
          >
            <img
              src={require('../../../assets/images/logo-spartacus.png')}
              style={{ width: 38, height: 38 }}
              alt="Spartacus"
            />
            {showEnvBadge ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span
                  style={{
                    fontSize: 17,
                    fontWeight: 300,
                    letterSpacing: 3,
                    textTransform: 'uppercase',
                  }}
                >
                  {appConfig.siteName}
                </span>
                <span
                  style={{
                    fontSize: 9,
                    fontWeight: 700,
                    letterSpacing: 1,
                    textTransform: 'uppercase',
                    color: envStyle.color,
                    backgroundColor: envStyle.bg,
                    padding: '1px 10px',
                    borderRadius: 4,
                    border: `1px solid ${envStyle.color}`,
                    marginTop: 1,
                  }}
                >
                  {environment}
                </span>
              </div>
            ) : (
              <span
                style={{
                  fontSize: 21,
                  fontWeight: 300,
                  letterSpacing: 3,
                  textTransform: 'uppercase',
                }}
              >
                {appConfig.siteName}
              </span>
            )}
          </Link>
        </h3>
      )}
    </div>
  );
};

export default Logo;
